import DataTable from "../../../components/Table";
import type { ColumnsType } from "antd/es/table";
import { Row, Col, Button, Space, Popconfirm, message, Image } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { fetchPodcast } from "../../../redux/slice/podcastSlice";
import AddPodcast from "./add";
import { callDeletePodcast } from "../../../config/api";
import ModalPodcast from "./edit";
import DateFormat from "../../../utils/formatTime/DateFormat";
import { FORMAT_DATE_DISPLAY } from "../../../utils/constants/timeFormat";
import ViewDetail from "./detail/ViewDetail";
import PodcastSearch from "./PodcastSearch";

function ManagePodcast() {
  const [searchPagination, setSearchPagination] = useState(
    "current=1&pageSize=5"
  );
  const [searchData, setSearchData] = useState("");
  const dispatch = useAppDispatch();
  const categories = useAppSelector((state) => state.podcast);
  const [dataViewDetail, setDataViewDetail] = useState("");
  const [openViewDetail, setOpenViewDetail] = useState(false);

  const columns: ColumnsType<any> = [
    {
      title: "ID",
      dataIndex: "_id",
      render: (text, record: any) => {
        return (
          <span
            style={{ color: "#4986ff", cursor: "pointer" }}
            onClick={() => {
              setDataViewDetail(record);
              setOpenViewDetail(true);
            }}>
            {text}
          </span>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
    },

    {
      title: "CreatedAt",
      dataIndex: "createdAt",
      render: (text) => {
        return (
          <>
            <DateFormat time={text} format={FORMAT_DATE_DISPLAY} />
          </>
        );
      },
    },
    {
      title: "Image",
      dataIndex: "image",
      render: (text) => {
        return (
          <>
            <Image width={36} src={text} />
          </>
        );
      },
    },
    {
      title: "UpdatedAt",
      dataIndex: "updatedAt",
      render: (text) => {
        return (
          <>
            <DateFormat time={text} format={FORMAT_DATE_DISPLAY} />
          </>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (_, record: any) => (
        <Space size="middle">
          <ModalPodcast
            id={record._id}
            handleFetchPodcast={handleFetchPodcast}
          />
          <Popconfirm
            placement="leftTop"
            title={"Xác nhận xóa user"}
            description={"Bạn có chắc chắn muốn xóa user này ?"}
            onConfirm={() => handleDeletePodcast(record._id)}
            okText="Xác nhận"
            cancelText="Hủy">
            <Button type="primary" danger ghost>
              <DeleteOutlined />
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  let query = `${searchPagination}${searchData}`;

  const handleDeletePodcast = async (id: string) => {
    const result = await callDeletePodcast(id);
    if (result.statusCode === 200) {
      handleFetchPodcast();
      message.success("delete success!");
    } else {
      message.error("delete failed!");
    }
  };

  const handleFetchPodcast = () => {
    dispatch(fetchPodcast({ query }));
  };
  useEffect(() => {
    handleFetchPodcast();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const handleModalCreate = (): JSX.Element => {
    return (
      <>
        <AddPodcast handleFetchPodcast={handleFetchPodcast} />
      </>
    );
  };

  const handleSearch = (paramSearch: any) => {
    setSearchData(paramSearch);
  };

  return (
    <>
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <PodcastSearch handleSearch={handleSearch} />
        </Col>
      </Row>
      <DataTable
        columns={columns}
        data={categories?.result}
        loading={categories.isFetching}
        total={categories?.meta.total}
        modalAdd={handleModalCreate}
        name={"Categories"}
        setSearchPagination={setSearchPagination}
      />
      <ViewDetail
        openViewDetail={openViewDetail}
        dataViewDetail={dataViewDetail}
        setOpenViewDetail={setOpenViewDetail}
      />
    </>
  );
}

export default ManagePodcast;
